import { render, staticRenderFns } from "./listaTemplate.vue?vue&type=template&id=4b2a24f8&"
import script from "./listaTemplate.vue.ts?vue&type=script&lang=ts&"
export * from "./listaTemplate.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports